<template>
  <div class="navigation-box">
    <BaseTile class="navigation-tile">
      <template v-slot:headertext>
        <p v-html="$t('widget_details.navigation_title')" class="subtitle"></p>
      </template>
      <template v-slot:bodytext>
        <ul class="navbox-list">
          <li>
            <a id="termLink" tabindex="0" @keyup.enter="onEnter" @click="termOfServiceModal()" class="navbox-link">
              {{ $t("term_service.term_service_title") }}
            </a>
          </li>
          <li>
            <a id="browserLink" tabindex="0" @keyup.enter="onEnter" @click="scrollMeTo('browser_support')" class="navbox-link">
              {{ $t("browser_support.browser_support_title") }}
            </a>
          </li>
          <li v-if="widget.id != '5'">
            <a id="sourceLink" tabindex="0" @keyup.enter="onEnter" @click="scrollMeTo('widget_source')" class="navbox-link">
              {{ $t("widget_source.widget_source_title") }}
            </a>
          </li>
          <li v-if="widget.id != '5'">
            <a id="usingLink" tabindex="0" @keyup.enter="onEnter" @click="scrollMeTo('using_the_widget')" class="navbox-link">{{
              $t("widget_details.usage_title")
            }}</a>
            <ul class="navbox-list">
              <li>
                <a id="step1" tabindex="0" @keyup.enter="onEnter" @click="scrollMeTo('step_one')" class="navbox-link">{{
                  $t("widget_details.step_one")
                }}</a>
              </li>
              <li>
                <a id="step2" tabindex="0" @keyup.enter="onEnter" @click="scrollMeTo('step_two')" class="navbox-link">{{
                  $t("widget_details.step_two")
                }}</a>
              </li>
              <li>
                <a id="step3" tabindex="0" @keyup.enter="onEnter" @click="scrollMeTo('step_three')" class="navbox-link">{{
                  $t("widget_details.step_three")
                }}</a>
              </li>
              <li
                v-if="widget.id == '1' || widget.id == '2' || widget.id == '4'"
              >
                <a id="step4" tabindex="0" @keyup.enter="onEnter" @click="scrollMeTo('step_four')" class="navbox-link">{{
                  $t("widget_details.step_four")
                }}</a>
              </li>
              <li
                v-if="widget.id == '1' || widget.id == '2' || widget.id == '4'"
              >
                <a id="step5" tabindex="0" @keyup.enter="onEnter" @click="scrollMeTo('step_five')" class="navbox-link">{{
                  $t("widget_details.step_five")
                }}</a>
              </li>
            </ul>
          </li>
          <li v-if="widget.id != '5'">
            <a id="attrLink" tabindex="0" @keyup.enter="onEnter" @click="scrollMeTo('custom_attributes')" class="navbox-link">{{
              $t("widget_details.custom_attributes")
            }}</a>
          </li>
          <li v-if="widget.id != '5'">
            <a
              id="faqLink"
              tabindex="0" 
              v-html="$t('widget_details.faq')"
              @keyup.enter="onEnter"
              @click="scrollMeTo('faq')"
              class="navbox-link"
            ></a>
          </li>
        </ul>
      </template>
      <template v-slot:footertext></template>
    </BaseTile>
  </div>
</template>

<script>
import BaseTile from "@/components/base-components/BaseTile.vue";
import TermOfServiceModal from "@/components/TermOfServiceModal.vue";

export default {
  name: "NavigationBox",
  props: {
    widget: { type: Object, required: true }
  },
  components: {
    BaseTile
  },
  methods: {
    scrollMeTo(refName) {
      var element = this.$parent.$refs[refName];
      var top = element.offsetTop;

      window.scrollTo(0, top);
    },
    onEnter(event) {
      if (event) {
        document.getElementById(event.target.id).click()
      }
    },
    termOfServiceModal: function() {
      this.$buefy.modal.open({
        parent: this,
        component: TermOfServiceModal,
        hasModalCard: true
      });
    }
  }
};
</script>

<style scoped lang="scss">
.navigation-tile .custom-tile {
  display: flex;
  flex-direction: column;
}
.navbox-link {
  text-decoration: underline;
}
.navbox-list {
  list-style-type: none;
}
</style>
